import React from 'react';

import introImg from '../../../../assets/images/courses/teamplayer&collaboration/chapter14.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { MediaBlock } from '../../MediaBlock';

interface TeamPlayersAndCollaborationChapter1 {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersAndCollaborationChapter14: React.FC<
  TeamPlayersAndCollaborationChapter1
> = ({ chapter, onNextChapter, totalPages }) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Foster Psychological Safety</h2>
        <br />
        <MediaBlock mediaImage={introImg}></MediaBlock>
        <br />
        <h3 className="text-2xl mt-2 text-center font-light mb-5">
          In conclusion, great teamwork is about being open, respectful, and actively involved. By
          embracing different ideas, communicating clearly, and working together on decisions, teams
          can overcome challenges, use everyone's strengths, and succeed more.
        </h3>
        <br />
        <p className="text-xl font-semibold mt-8 mb-8">
          Throughout this lesson, you have learned to:
        </p>
        <ul className="list-disc pl-5 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">
            Build trusted relationships by being fully engaged and clear about expectations.
          </li>
          <li className="pl-9 mb-7">
            Create a safe environment where everyone feels comfortable sharing ideas.
          </li>
          <li className="pl-9 mb-7">
            Develop a positive team culture that encourages respect and cooperation.
          </li>
          <li className="pl-9 mb-7">
            Think strategically to help solve problems and make better decisions.
          </li>
          <li className="pl-9 mb-7">Handle conflicts in a confident and constructive way.</li>
          <li className="pl-9 mb-7">
            Avoid common teamwork problems like groupthink and risky decisions.
          </li>
          <li className="pl-9 mb-7">
            Take steps to keep improving your teamwork and collaboration skills.{' '}
          </li>
        </ul>
        <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-5">Reminders</h3>
        <p className="text-xl font-semibold mb-8">
          Teamwork is not just about working together, but also about learning from each other and
          growing as a team. Remember the following collaboration and teamwork strategies:
        </p>
        <ul className="list-disc pl-5 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">Share what you know and be open to learning from others.</li>
          <li className="pl-9 mb-7">Participate in team activities.</li>
          <li className="pl-9 mb-7">Appreciate diversity and learn from different perspectives.</li>
          <li className="pl-9 mb-7">Lead by being a positive example.</li>
          <li className="pl-9 mb-7">Address conflicts quickly and honestly.</li>
          <li className="pl-9 mb-7">Show appreciation and gratitude regularly.</li>
          <li className="pl-9 mb-7">Keep communication open.</li>
          <li className="pl-9 mb-7">Share your ideas and join in decision-making.</li>
          <li className="pl-9 mb-7">Respect and support your teammates.</li>
        </ul>
        <p className="text-lg text-center font-semibold mb-8">
          By following these tips and strategies outlined in this module, you can help create a team
          environment where everyone feels valued and motivated to do their best. Together, you can
          achieve more and keep improving and succeeding.
        </p>

        <br />
        <h3 className="text-2xl mt-2 text-center font-light mb-5">
          You have now completed the Teamwork & Collaboration course. Let's see how far you have
          come along on this journey and complete the post-assessment.
        </h3>
        <br />
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Post-Assessment
        </button>
      </div>
    </>
  );
};
